import { Link, useLocation } from "react-router-dom";
import { CheckCircle2, MessageCircle, Clock } from "lucide-react";
import { Logo } from "@/components/Logo";

const SITUATION_MESSAGES = {
  "J'ai de l'expérience mais pas de date": {
    lead: "On te trouve une date d'examen au plus vite.",
    body: "Tu sais déjà conduire : nous sélectionnons l'auto-école de notre réseau la mieux placée pour te proposer une place en formation accélérée — à commencer par notre partenaire principal (130+ avis 5★). Tu recevras ses coordonnées par email et tu la contacteras sous 2 jours.",
  },
  "J'ai échoué et je veux passer en campagne": {
    lead: "On t'oriente vers un centre en campagne.",
    body: "Fini le stress des grands centres : nous te mettons en relation avec l'auto-école de notre réseau la plus adaptée — dont notre partenaire principal, noté 130+ avis 5★ (réussite en ~1,5 passage). Tu recevras ses coordonnées par email et tu la contacteras sous 2 jours.",
  },
  "Je veux un permis accéléré": {
    lead: "On cale ton permis accéléré.",
    body: "Nous sélectionnons l'auto-école de notre réseau capable d'enchaîner conduite et examen au plus vite — à commencer par notre partenaire principal (130+ avis 5★). Tu recevras ses coordonnées par email et tu la contacteras sous 2 jours.",
  },
};

const DEFAULT_MESSAGE = {
  lead: "Ta demande est bien reçue.",
  body: "PlanPermis n'est pas une auto-école : nous sélectionnons l'auto-école de notre réseau de partenaires la plus adaptée à ta situation — à commencer par notre partenaire principal (130+ avis 5★, réussite en ~1,5 passage en cursus classique). Tu recevras ses coordonnées par email, et c'est toi qui la contactes sous 2 jours.",
};

export default function Merci() {
  const { state } = useLocation();
  const msg = (state?.situation && SITUATION_MESSAGES[state.situation]) || DEFAULT_MESSAGE;
  const body = msg.body;

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white grain relative px-6 py-24">
      <div className="relative z-10 mx-auto max-w-xl">
        <Logo dark />
        <CheckCircle2 className="mt-16 h-12 w-12 text-emerald-400" />
        <h1 className="mt-6 text-4xl sm:text-5xl font-extrabold tracking-tighter leading-none" data-testid="thankyou-title">
          C'est envoyé{state?.first_name ? `, ${state.first_name}` : ""}.
        </h1>
        <p className="mt-6 text-xl font-bold text-brand" data-testid="thankyou-lead">
          {msg.lead}
        </p>
        <p className="mt-3 text-neutral-300 leading-relaxed" data-testid="thankyou-school">
          {body}
        </p>
        <p
          className="mt-4 inline-flex items-center gap-2 rounded-full bg-white/10 px-4 py-2 text-sm font-semibold text-white"
          data-testid="thankyou-delay"
        >
          <Clock className="h-4 w-4 text-emerald-400" /> Coordonnées envoyées par email sous 24 à 48 h
        </p>
        <p className="mt-4 text-sm text-neutral-400">Un email de confirmation vient de t'être envoyé.</p>
        <a
          href="https://wa.me/33752980486?text=Bonjour%2C%20je%20viens%20de%20remplir%20le%20formulaire%20PlanPermis."
          target="_blank"
          rel="noreferrer"
          data-testid="thankyou-whatsapp"
          className="mt-10 inline-flex items-center gap-3 rounded-full bg-[#25D366] px-6 py-3.5 font-bold text-black transition-transform hover:scale-[1.02]"
        >
          <MessageCircle className="h-4 w-4" /> Une question ? Écris-nous sur WhatsApp
        </a>
        <br />
        <Link
          to="/"
          data-testid="back-home-link"
          className="mt-6 inline-block rounded-full bg-brand px-8 py-4 font-bold text-white transition-colors hover:bg-brand-hover"
        >
          Retour à l'accueil
        </Link>
      </div>
    </div>
  );
}
